import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import MaterialTabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tabsRoot: {
    borderBottom: `1px solid #ebecec`
  },
  tabsIndicator: {
    backgroundColor: `#949899`
  },
  flexContainer: {
    flexWrap: `wrap`
  },
  tabRoot: {
    "fontSize": `15px`,
    "textTransform": `initial`,
    "minWidth": 72,
    "fontWeight": theme.typography.fontWeightRegular,
    "fontFamily": [
      `Formular`,
      `-apple-system`,
      `BlinkMacSystemFont`,
      `"Segoe UI"`,
      `Roboto`,
      `"Helvetica Neue"`,
      `Arial`,
      `sans-serif`,
      `"Apple Color Emoji"`,
      `"Segoe UI Emoji"`,
      `"Segoe UI Symbol"`
    ].join(`,`),
    "&:hover": {
      color: `#949899`,
      opacity: 1
    },
    "&$tabSelected": {
      color: `#949899`,
      fontWeight: theme.typography.fontWeightMedium
    },
    "&:focus": {
      color: `#949899`
    }
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing.unit * 3
  }
});

class Tabs extends React.Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({value});
  };
  handleChangeIndex = (index) => {
    this.setState({value: index});
  };
  createMarkup(__html) {
    return {__html};
  }
  render() {
    const {classes, tabs} = this.props;
    const {value} = this.state;

    return (
      <div className={classes.root}>
        <MaterialTabs
          variant="fullWidth"
          value={value}
          onChange={this.handleChange}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator,
            flexContainer: classes.flexContainer
          }}
        >
          {tabs.map(({tab_header: header}) => (
            <Tab
              key={header}
              disableRipple
              component="h3"
              classes={{root: classes.tabRoot, selected: classes.tabSelected}}
              label={header}
            />
          ))}
        </MaterialTabs>
        <SwipeableViews
          axis={`x`}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
        >
          {tabs.map(({tab_header: tabHeader, text}) => (
            <div key={tabHeader}>
              <div dangerouslySetInnerHTML={this.createMarkup(text)} />
            </div>
          ))}
        </SwipeableViews>
      </div>
    );
  }
}

Tabs.propTypes = {
  classes: PropTypes.object.isRequired,
  tabs: PropTypes.array
};

export default withStyles(styles)(Tabs);
